export const SERVICE_CODE = 'EXPENSE' + '_ATTACHMENT' + '_SERVICE';
